import classnames from 'classnames';
import { useRef, useEffect, useCallback } from 'react';
import SignaturePad from 'signature_pad';

import { Button } from '../Button/Button';

import styles from './SignatureDrawer.module.scss';
import { Props } from './SignatureDrawer.types';

export const SignatureDrawer = ({ size, onEnd, onClear, disabled }: Props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const signaturePad = useRef<{ pad?: SignaturePad }>({ pad: undefined });

  const onEndStroke = useCallback(
    () => onEnd?.(signaturePad.current.pad?.toDataURL('image/png')),
    [onEnd]
  );

  useEffect(() => {
    if (!canvasRef.current) return;
    if (!signaturePad.current.pad) signaturePad.current.pad = new SignaturePad(canvasRef.current);
    const pad = signaturePad.current.pad;
    if (disabled) pad.off();
    else pad.on();
    pad.addEventListener('endStroke', onEndStroke);
    return () => pad.removeEventListener('endStroke', onEndStroke);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasRef.current, onEndStroke, disabled]);

  return (
    <div className={styles.container}>
      <canvas
        className={classnames({ [styles.disabled]: disabled })}
        width={size?.width ?? 672}
        height={size?.height ?? 210}
        ref={canvasRef}
      />
      <div className={styles.header}>tracez votre signature</div>
      <Button
        variant="tertiary"
        size="small"
        className={styles.clearButton}
        disabled={disabled}
        onClick={() => {
          signaturePad.current.pad?.clear();
          onClear?.();
        }}
      >
        effacer
      </Button>
    </div>
  );
};
